/**
 * View component for /course-certificates
 *
 * Generic courseCertificate list view. Defaults to 'all' with:
 * this.props.dispatch(courseCertificateActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import actions
import * as courseCertificateActions from '../courseCertificateActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import courseCertificate components
import CourseCertificateLayout from '../components/CourseCertificateLayout.js.jsx';
import CourseCertificateListItem from '../components/CourseCertificateListItem.js.jsx';

// import courseCertificate css modules
import courseCertificateStyles from '../courseCertificateModuleStyles.css';

class CourseCertificateList extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // fetch a list of your choice
    this.props.dispatch(courseCertificateActions.fetchListIfNeeded()); // defaults to 'all'
  }

  render() {
    const { courseCertificateStore } = this.props;

    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */

    // get the courseCertificateList meta info here so we can reference 'isFetching'
    const courseCertificateList = courseCertificateStore.lists ? courseCertificateStore.lists.all : null;

    /**
     * use the reducer getList utility to convert the all.items array of ids
     * to the actual courseCertificate objetcs
     */
    const courseCertificateListItems = courseCertificateStore.util.getList("all");

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = !courseCertificateListItems || !courseCertificateList;

    return (
      <CourseCertificateLayout>
        <Helmet
          title={"Certificates | Pro-ficiency"}
        />
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h1> Course Certificate List
                <Link className="yt-btn small u-pullRight" to={'/course-certificates/new'}> NEW Course Certificate </Link>
              </h1>
              <hr/>
              { isEmpty ?
                (courseCertificateListItems && courseCertificateList.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: courseCertificateList.isFetching ? 0.5 : 1 }}>
                  <ul>
                    {courseCertificateListItems.map((courseCertificate, i) =>
                      <CourseCertificateListItem key={courseCertificate._id + i} courseCertificate={courseCertificate} />
                    )}
                  </ul>
                </div>
              }
            </div>
          </section>
        </div>
      </CourseCertificateLayout>
    )
  }
}

CourseCertificateList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    courseCertificateStore: store.courseCertificate
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(CourseCertificateList)
);



// WEBPACK FOOTER //
// modules/courseCertificate/views/CourseCertificateList.js.jsx